export default __webpack_public_path__ + "static/custom-LMS-integrating-design-tools-1b6bfdbefeca6940136a8484e2e67e24.jpg";